import { createSlice } from "@reduxjs/toolkit";
import { requestAppointmentRescheduleReducer } from "../../reducer/requestAppointmentReschedule/requestAppointmentRescheduleReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const requestAppointmentRescheduleSlice = createSlice({
  name: "requestAppointmentReschedule",
  initialState,
  reducers: {
    resetRequestAppointmentReschedule: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestAppointmentRescheduleReducer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        requestAppointmentRescheduleReducer.fulfilled,
        (state, action) => {
          state.loading = false;
          state.data = action.payload;
        },
      )
      .addCase(
        requestAppointmentRescheduleReducer.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );
  },
});

export const { resetRequestAppointmentReschedule } =
  requestAppointmentRescheduleSlice.actions;

export default requestAppointmentRescheduleSlice.reducer;
